exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#order-form{margin-bottom:2rem}#order-form .form-group{position:relative}#order-form .invalid-feedback{position:absolute;left:10px}.short-list{display:none;overflow-wrap:break-word}.route-mail{max-width:300px}@media (max-width:536px){#routes-table{display:none}.short-list{display:block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27ced940","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/OrderStatus.vue
// module id = 689
// module chunks = 0